import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import React from 'react';
import {Queue} from '@mui/icons-material'

export const TabsPanelButton = React.memo((props: TopNavBarButtonProps) => (
	<TopNavBarButtonComponent variant={'outlined'}{...props}>
		<Queue fontSize={'small'}/>
		{props.btnDef?.label && <>&nbsp;{props.btnDef?.label}</>}
	</TopNavBarButtonComponent>
));